module.exports = __webpack_public_path__ + "static/img/product_img4.27e4e57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_img4.png
// module id = m2CS
// module chunks = 0